import { Component, Input } from '@angular/core';
import { Loader } from '@shared/components/loader/loader.model';
import { LoaderEllipsisComponent } from '@shared/components/loader/ellipsis/ellipsis.component';

@Component({
    selector: 'infinite-loader',
    imports: [LoaderEllipsisComponent],
    templateUrl: './infinite-loader.component.html',
    styleUrl: './infinite-loader.component.scss'
})
export class InfiniteLoaderComponent {
  @Input() loader!: Loader;
}
